import { makeStore } from './app/app';
import { makeApolloClient } from './config/graphql';

export const apolloClient = makeApolloClient();
export const store = makeStore(apolloClient);
apolloClient.setReduxStore(store);
